/* eslint-disable @next/next/no-head-element */
/* eslint-disable @next/next/no-page-custom-font */
import { ReactNode } from 'react';
import { ibmPlexSans, ibmPlexMono } from '@/components/jc/fonts';
import { SessionProvider } from 'next-auth/react';

import '../../../app/globals.css';
import './DefaultLayoutJC.css';

import FooterJC from '../FooterJC';
import HeaderJC from '../HeaderJC';
import SkipLink, { MAIN_CONTENT_ID } from '@/components/common/skip-link';

interface LayoutProps {
  children: ReactNode;
}

const DefaultLayoutJC = async ({ children }: LayoutProps) => {
  return (
    <html lang="en" className={`${ibmPlexSans.variable} ${ibmPlexMono.variable}`}>
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </head>
      <body className="body-jc">
        <SessionProvider session={null}>
          <link rel="shortcut icon" href="/jc/favicon.ico" />
          <div className="h-full flex flex-col justify-between">
            <div>
              <SkipLink />
              <HeaderJC />
              <main id={MAIN_CONTENT_ID} tabIndex={-1} className="outline-none">
                {children}
              </main>
            </div>
            <div>
              <FooterJC isAuthorized={false} />
            </div>
          </div>
        </SessionProvider>
      </body>
    </html>
  );
};

export default DefaultLayoutJC;
